// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/environment_automation.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateServiceRequest, CreateServiceResponse, CreateTaskRequest, CreateTaskResponse, DeleteServiceRequest, DeleteServiceResponse, DeleteTaskRequest, DeleteTaskResponse, GetServiceRequest, GetServiceResponse, GetTaskExecutionRequest, GetTaskExecutionResponse, GetTaskRequest, GetTaskResponse, ListServicesRequest, ListServicesResponse, ListTaskExecutionsRequest, ListTaskExecutionsResponse, ListTasksRequest, ListTasksResponse, StartServiceRequest, StartServiceResponse, StartTaskRequest, StartTaskResponse, StopServiceRequest, StopServiceResponse, StopTaskExecutionRequest, StopTaskExecutionResponse, UpdateServiceRequest, UpdateServiceResponse, UpdateTaskExecutionStatusRequest, UpdateTaskExecutionStatusResponse, UpdateTaskRequest, UpdateTaskResponse, UpsertAutomationsFileRequest, UpsertAutomationsFileResponse } from "./environment_automation_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.EnvironmentAutomationService
 */
export const EnvironmentAutomationService = {
  typeName: "gitpod.v1.EnvironmentAutomationService",
  methods: {
    /**
     * Creates a new automation service for an environment.
     *
     * Use this method to:
     * - Set up long-running services
     * - Configure service triggers
     * - Define service dependencies
     * - Specify runtime environments
     *
     * ### Examples
     *
     * - Create basic service:
     *
     *   Creates a simple service with start command.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   metadata:
     *     reference: "web-server"
     *     name: "Web Server"
     *     description: "Runs the development web server"
     *     triggeredBy:
     *       - postDevcontainerStart: true
     *   spec:
     *     commands:
     *       start: "npm run dev"
     *       ready: "curl -s http://localhost:3000"
     *   ```
     *
     * - Create Docker-based service:
     *
     *   Creates a service running in a specific container.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   metadata:
     *     reference: "redis"
     *     name: "Redis Server"
     *     description: "Redis cache service"
     *   spec:
     *     commands:
     *       start: "redis-server"
     *     runsOn:
     *       docker:
     *         image: "redis:7"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.CreateService
     */
    createService: {
      name: "CreateService",
      I: CreateServiceRequest,
      O: CreateServiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific automation service.
     *
     * Use this method to:
     * - Check service status
     * - View service configuration
     * - Monitor service health
     * - Retrieve service metadata
     *
     * ### Examples
     *
     * - Get service details:
     *
     *   Retrieves information about a specific service.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.GetService
     */
    getService: {
      name: "GetService",
      I: GetServiceRequest,
      O: GetServiceResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists automation services with optional filtering.
     *
     * Use this method to:
     * - View all services in an environment
     * - Filter services by reference
     * - Monitor service status
     *
     * ### Examples
     *
     * - List environment services:
     *
     *   Shows all services for an environment.
     *
     *   ```yaml
     *   filter:
     *     environmentIds: ["07e03a28-65a5-4d98-b532-8ea67b188048"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Filter by reference:
     *
     *   Lists services matching specific references.
     *
     *   ```yaml
     *   filter:
     *     references: ["web-server", "database"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.ListServices
     */
    listServices: {
      name: "ListServices",
      I: ListServicesRequest,
      O: ListServicesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an automation service configuration.
     *
     * Use this method to:
     * - Modify service commands
     * - Update triggers
     * - Change runtime settings
     * - Adjust dependencies
     *
     * ### Examples
     *
     * - Update commands:
     *
     *   Changes service start and ready commands.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   spec:
     *     commands:
     *       start: "npm run start:dev"
     *       ready: "curl -s http://localhost:8080"
     *   ```
     *
     * - Update triggers:
     *
     *   Modifies when the service starts.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   metadata:
     *     triggeredBy:
     *       trigger:
     *         - postDevcontainerStart: true
     *         - manual: true
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.UpdateService
     */
    updateService: {
      name: "UpdateService",
      I: UpdateServiceRequest,
      O: UpdateServiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an automation service. This call does not block until the service is deleted.
     * If the service is not stopped it will be stopped before deletion.
     *
     * Use this method to:
     * - Remove unused services
     * - Clean up service configurations
     * - Stop and delete services
     *
     * ### Examples
     *
     * - Delete service:
     *
     *   Removes a service after stopping it.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   force: false
     *   ```
     *
     * - Force delete:
     *
     *   Immediately removes a service.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   force: true
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.DeleteService
     */
    deleteService: {
      name: "DeleteService",
      I: DeleteServiceRequest,
      O: DeleteServiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Starts an automation service. This call does not block until the service is started.
     * This call will not error if the service is already running or has been started.
     *
     * Use this method to:
     * - Start stopped services
     * - Resume service operations
     * - Trigger service initialization
     *
     * ### Examples
     *
     * - Start service:
     *
     *   Starts a previously stopped service.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.StartService
     */
    startService: {
      name: "StartService",
      I: StartServiceRequest,
      O: StartServiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Stops an automation service. This call does not block until the service is stopped.
     * This call will not error if the service is already stopped or has been stopped.
     *
     * Use this method to:
     * - Pause service operations
     * - Gracefully stop services
     * - Prepare for updates
     *
     * ### Examples
     *
     * - Stop service:
     *
     *   Gracefully stops a running service.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.StopService
     */
    stopService: {
      name: "StopService",
      I: StopServiceRequest,
      O: StopServiceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Upserts the automations file for the given environment.
     *
     * Use this method to:
     * - Configure environment automations
     * - Update automation settings
     * - Manage automation files
     *
     * ### Examples
     *
     * - Update automations file:
     *
     *   Updates or creates the automations configuration.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   automationsFile:
     *     services:
     *       web-server:
     *         name: "Web Server"
     *         description: "Development web server"
     *         commands:
     *           start: "npm run dev"
     *           ready: "curl -s http://localhost:3000"
     *         triggeredBy:
     *           - postDevcontainerStart
     *     tasks:
     *       build:
     *         name: "Build Project"
     *         description: "Builds the project artifacts"
     *         command: "npm run build"
     *         triggeredBy:
     *           - postEnvironmentStart
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.UpsertAutomationsFile
     */
    upsertAutomationsFile: {
      name: "UpsertAutomationsFile",
      I: UpsertAutomationsFileRequest,
      O: UpsertAutomationsFileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new automation task.
     *
     * Use this method to:
     * - Define one-off or scheduled tasks
     * - Set up build or test automation
     * - Configure task dependencies
     * - Specify execution environments
     *
     * ### Examples
     *
     * - Create basic task:
     *
     *   Creates a simple build task.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   metadata:
     *     reference: "build"
     *     name: "Build Project"
     *     description: "Builds the project artifacts"
     *     triggeredBy:
     *       - postEnvironmentStart: true
     *   spec:
     *     command: "npm run build"
     *   ```
     *
     * - Create task with dependencies:
     *
     *   Creates a task that depends on other services.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   metadata:
     *     reference: "test"
     *     name: "Run Tests"
     *     description: "Runs the test suite"
     *   spec:
     *     command: "npm test"
     *   dependsOn: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.CreateTask
     */
    createTask: {
      name: "CreateTask",
      I: CreateTaskRequest,
      O: CreateTaskResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific automation task.
     *
     * Use this method to:
     * - Check task configuration
     * - View task dependencies
     * - Monitor task status
     *
     * ### Examples
     *
     * - Get task details:
     *
     *   Retrieves information about a specific task.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.GetTask
     */
    getTask: {
      name: "GetTask",
      I: GetTaskRequest,
      O: GetTaskResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists automation tasks with optional filtering.
     *
     * Use this method to:
     * - View all tasks in an environment
     * - Filter tasks by reference
     * - Monitor task status
     *
     * ### Examples
     *
     * - List environment tasks:
     *
     *   Shows all tasks for an environment.
     *
     *   ```yaml
     *   filter:
     *     environmentIds: ["07e03a28-65a5-4d98-b532-8ea67b188048"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Filter by reference:
     *
     *   Lists tasks matching specific references.
     *
     *   ```yaml
     *   filter:
     *     references: ["build", "test"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.ListTasks
     */
    listTasks: {
      name: "ListTasks",
      I: ListTasksRequest,
      O: ListTasksResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an automation task configuration.
     *
     * Use this method to:
     * - Modify task commands
     * - Update task triggers
     * - Change dependencies
     * - Adjust execution settings
     *
     * ### Examples
     *
     * - Update command:
     *
     *   Changes the task's command.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   spec:
     *     command: "npm run test:coverage"
     *   ```
     *
     * - Update triggers:
     *
     *   Modifies when the task runs.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   metadata:
     *     triggeredBy:
     *       trigger:
     *         - postEnvironmentStart: true
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.UpdateTask
     */
    updateTask: {
      name: "UpdateTask",
      I: UpdateTaskRequest,
      O: UpdateTaskResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an automation task.
     *
     * Use this method to:
     * - Remove unused tasks
     * - Clean up task configurations
     * - Delete obsolete automations
     *
     * ### Examples
     *
     * - Delete task:
     *
     *   Removes a task and its configuration.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.DeleteTask
     */
    deleteTask: {
      name: "DeleteTask",
      I: DeleteTaskRequest,
      O: DeleteTaskResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Starts a task by creating a new task execution.
     * This call does not block until the task is started; the task will be started asynchronously.
     *
     * Use this method to:
     * - Trigger task execution
     * - Run one-off tasks
     * - Start scheduled tasks immediately
     *
     * ### Examples
     *
     * - Start task:
     *
     *   Creates a new execution of a task.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.StartTask
     */
    startTask: {
      name: "StartTask",
      I: StartTaskRequest,
      O: StartTaskResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists executions of automation tasks.
     *
     * Use this method to:
     * - View task execution history
     * - Monitor running tasks
     * - Track task completion status
     *
     * ### Examples
     *
     * - List all executions:
     *
     *   Shows execution history for all tasks.
     *
     *   ```yaml
     *   filter:
     *     environmentIds: ["07e03a28-65a5-4d98-b532-8ea67b188048"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Filter by phase:
     *
     *   Lists executions in specific phases.
     *
     *   ```yaml
     *   filter:
     *     phases: ["TASK_EXECUTION_PHASE_RUNNING", "TASK_EXECUTION_PHASE_FAILED"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.ListTaskExecutions
     */
    listTaskExecutions: {
      name: "ListTaskExecutions",
      I: ListTaskExecutionsRequest,
      O: ListTaskExecutionsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets details about a specific task execution.
     *
     * Use this method to:
     * - Monitor execution progress
     * - View execution logs
     * - Check execution status
     * - Debug failed executions
     *
     * ### Examples
     *
     * - Get execution details:
     *
     *   Retrieves information about a specific task execution.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.GetTaskExecution
     */
    getTaskExecution: {
      name: "GetTaskExecution",
      I: GetTaskExecutionRequest,
      O: GetTaskExecutionResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Stops a running task execution.
     *
     * Use this method to:
     * - Cancel long-running tasks
     * - Stop failed executions
     * - Interrupt task processing
     *
     * ### Examples
     *
     * - Stop execution:
     *
     *   Stops a running task execution.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.StopTaskExecution
     */
    stopTaskExecution: {
      name: "StopTaskExecution",
      I: StopTaskExecutionRequest,
      O: StopTaskExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the status of a task execution.
     * Only the environment executing a task execution is expected to call this function.
     *
     * Use this method to:
     * - Report execution progress
     * - Update step status
     * - Set failure messages
     * - Provide log URLs
     *
     * ### Examples
     *
     * - Update execution status:
     *
     *   Updates status with step information.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   steps:
     *     - id: "step-1"
     *       phase: TASK_EXECUTION_PHASE_SUCCEEDED
     *   logUrl: "https://logs.gitpod.io/task-123"
     *   ```
     *
     * - Report failure:
     *
     *   Updates status with failure information.
     *
     *   ```yaml
     *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   failureMessage: "Build failed due to missing dependencies"
     *   steps:
     *     - id: "step-1"
     *       phase: TASK_EXECUTION_PHASE_FAILED
     *       failureMessage: "npm install failed"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentAutomationService.UpdateTaskExecutionStatus
     */
    updateTaskExecutionStatus: {
      name: "UpdateTaskExecutionStatus",
      I: UpdateTaskExecutionStatusRequest,
      O: UpdateTaskExecutionStatusResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

